:host {
  display: block;
  max-width: 100%;
}

gz-form-field {
  --margin-bottom-wrapper: 0;
  --form-field-label-width: 160px;
  &#ratingField {
    &::part(form-field-label) {
      padding-top: 0;
      display: flex;
      align-items: center;
      min-height: 24px;
    }
  }
}

gz-textarea {
  --input-height: 64px;
}

gz-input-error {
  margin-top: -4px;
}
